import { useQuery, useMutation } from "@tanstack/react-query";
import {
  apiDelete,
  apiGet,
  apiPost,
  apiUpdate,
  apiPutFormData,
} from "api/api-auth";

// ✅ Generic Fetch Hook
export const useFetch = (key, url, params = {}) => {
  return useQuery({
    queryKey: [key, params], // ✅ React Query will detect changes
    queryFn: () => apiGet(url, params),
    keepPreviousData: true, // Prevents unnecessary loading states during pagination
    staleTime: 300000, // Cache data for 5 minutes
    cacheTime: 10 * 60 * 1000,
    retry: 2,
  });
};

export const usePost = (key, url) => {
  return useMutation({
    mutationFn: (data) => {
      return apiPost(url, data);
    },
    onError: (error) => {
      console.error(`${key} error:`, error);
    },
  });
};

export const useUpdate = (key, url) => {
  return useMutation({
    mutationFn: ({ params, data }) => {
      console.log("params", params);
      const queryParams = new URLSearchParams(params).toString();
      return apiUpdate(`${url}/${params.id}`, data); // ✅ Append params dynamically
    },
    onError: (error) => {
      console.error(`${key} update error:`, error);
    },
  });
};
export const usePut = (key, url) => {
  return useMutation({
    mutationFn: ({ params, data }) => {
      const queryParams = new URLSearchParams(params).toString();

      console.log(data, "ssssed", queryParams.length,`${url}${queryParams.length > 0 ? `/${queryParams}` : ""}`);

      return apiPutFormData(
        `${url}${queryParams.length > 0 ? `/${queryParams}` : ""}`,
        data
      ); // ✅ Append params dynamically
    },
    onError: (error) => {
      console.error(`${key} update error:`, error);
    },
  });
};

export const useDelete = (key, url) => {
  return useMutation({
    mutationFn: (params) => {
      const [paramKey, paramValue] = Object.entries(params)[0]; // ✅ Extract first key-value pair dynamically
      return apiDelete(`${url}/${paramValue}`); // ✅ Correct URL format
    },
    onError: (error) => {
      console.error(`${key} delete error:`, error);
    },
  });
};
